"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MilitaryService_1 = require("./MilitaryService");
exports.MilitaryService = MilitaryService_1.MilitaryService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy90ZXN0L1NhbXBsZS9wYXJ0cy9NaWxpdGFyeVNlcnZpY2UvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxxREFBaUQ7QUFBekMsNENBQUEsZUFBZSxDQUFBIn0=